module.exports = __webpack_public_path__ + "img/simvestor-0.6673df2f.png";